module.exports = __webpack_public_path__ + "img/@tmp_hrdcloud_06.a3a65422.jpg";